import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration with fallback defaults
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC77hhIKFB5qbbRQTA0XaAbVeRd5NYGerM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "homeowner-c8368.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "homeowner-c8368",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "homeowner-c8368.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "81288662484",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:81288662484:web:bef696d4582161da419a41",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-TTNWTNCT32",
};

// Initialize Firebase (singleton)
let app: any;
let auth: any;
try {
  app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
  auth = getAuth(app);
} catch (err) {
  console.error("Firebase init error:", err);
}

export { auth };

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

// Apple Auth Provider
export const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");

export default app;
